import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconEditNote = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.16602 11.0767V13.3333H9.42265L16.0782 6.67778L13.8216 4.42115L7.16602 11.0767ZM17.8233 4.93265C18.058 4.69796 18.058 4.31884 17.8233 4.08416L16.4152 2.67602C16.1805 2.44133 15.8014 2.44133 15.5667 2.67602L14.4655 3.77725L16.7221 6.03388L17.8233 4.93265Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.66667 2.5H3V17.5H18V10H16.3333V15.8333H4.66667V4.16667H9.66667V2.5Z",
		fill: "currentColor"
	})]
});
export default SvgIconEditNote;
